import { render, staticRenderFns } from "./PostListItem.vue?vue&type=template&id=64e365fd&lang=pug"
import script from "./PostListItem.vue?vue&type=script&lang=ts"
export * from "./PostListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports